import scrollToDiv from '../util/scroll-to-div';

const $ = jQuery;

export default class SingleAccessoriesRoute {
  constructor() {
    this.addEvents();
    this.modifyDOM();
  }

  addEvents() {
    $('body').on('click', '.relatedItemsToggler', this.toggleAccessories)
             .on('click', '.product-gallery__list__item', this.showProductImage)
             .on('click', '.show-specs', this.showSpecs);
  }

  modifyDOM() {
  }

  showProductImage(e) {
    const $el = $(e.currentTarget);
    const src = $el.find('img').prop('src');
    const $gallery = $el.closest('.product-gallery');

    $gallery.find('.product-gallery__list__item').removeClass('active');
    $gallery.find('.product-gallery__view img').prop('src', src);
    $el.addClass('active');
  }

  toggleAccessories() {
    const prevText = $(this).text();
    const nextText = $(this).data('text');
    $(this).text(nextText);
    $(this).data('text', prevText);
    $('.relatedItems').toggleClass('expanded');
    return false;
  }

  showSpecs() {
    scrollToDiv($('.infoAccordions'), undefined, 'top', 200);
    return false;
  }
}
